export default "__VITE_ASSET__BWGQlylC__"